import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import style from "./About.module.css";

const About = () => {
  return (
    <>
      <Navbar />

      <div className={style.about}>

        {/* HERO */}
        <section className={style.hero}>
          <div className={style.overlay}>
            <h1>One Step To Fitness</h1>
            <p>
              A video-based fitness and wellness platform designed to help
              you stay active, flexible, and healthy — one video at a time.
            </p>
          </div>
        </section>

        
        <section className={style.section}>
          <div className={style.text}>
            <h2>Fitness That Fits Into Your Life</h2>
            <p>
              One Step To Fitness is built for people who want simple,
              easy-to-follow fitness videos without complexity.
            </p>
            <p>
              Whether you have 10 minutes or an hour, our videos help you
              move better, stay consistent, and feel healthier every day.
            </p>
          </div>
          <div className={style.image}>
            <img src="/assets/images/content.png" alt="Fitness videos" />
          </div>
        </section>

       
        <section className={`${style.bgSection} ${style.bgAerobics}`}>
          <div className={style.overlay}>
            <h2>Aerobics Videos For Energy & Movement</h2>
            <p>
              High-energy aerobics videos designed to keep your body moving
              and your heart active. Perfect for daily cardio and full-body
              movement.
            </p>
          </div>
        </section>

        {/* yoga */}
        <section className={style.sectionReverse}>
          <div className={style.image}>
            <img src="/assets/images/yoga1.jpg" alt="Yoga videos" />
          </div>
          <div className={style.text}>
            <h2>Yoga Videos For Balance & Flexibility</h2>
            <p>
              Yoga videos focused on flexibility, posture, breathing,
              and relaxation. Suitable for beginners and regular practitioners.
            </p>
            <p>
              These videos help reduce stress while improving mobility
              and inner calm.
            </p>
          </div>
        </section>

        {/* exercise */}
        <section className={`${style.bgSection} ${style.bgExercise}`}>
          <div className={style.overlay}>
            <h2>Exercise Videos For Everyday Strength</h2>
            <p>
              Simple exercise videos that help maintain strength, endurance,
              and movement using easy techniques and bodyweight exercises.
            </p>
          </div>
        </section>

        {/* Wellness */}
        <section className={`${style.bgSection} ${style.bgNutrition}`}>
          <div className={style.overlay}>
            <h2>Wellness & Nutrition Awareness</h2>
            <p>
              Wellness and nutrition videos that help you understand healthy
              habits, mindful eating, hydration, and daily lifestyle balance.
            </p>
            <p>
              Because true fitness is not just about movement — it’s about
              how you live every day.
            </p>
          </div>
        </section>

        {/* health tips */}
        <section className={style.section}>
          <div className={style.text}>
            <h2>Health Tips That Support Daily Life</h2>
            <p>
              Short and practical health tip videos focused on posture,
              breathing, recovery, sleep habits, and everyday wellness.
            </p>
            <p>
              Small knowledge leads to long-term health improvements.
            </p>
          </div>
          <div className={style.image}>
            <img src="/assets/images/content1.png" alt="Health tips" />
          </div>
        </section>

        {/* message*/}
        <section className={`${style.bgSection} ${style.bgClosing}`}>
          <div className={style.overlay}>
            <h2>Your Fitness Journey Starts With One Click</h2>
            <p>
              You don’t need perfection — you need consistency.
              Press play, follow along, and take one step closer to a
              healthier you, every single day.
            </p>
          </div>
        </section>

      </div>

      <Footer />
    </>
  );
};

export default About;
